module.exports = __webpack_public_path__ + "img/14product.6785b0b9.svg";